module.exports = __webpack_public_path__ + "static/media/callLogo.e78a94fb.svg";